import type {BridgeComponentConstructor} from '../types';
import {createReactDriver} from './react';
import {createVue3Driver} from './vue';
import {createAngularDriver} from './angular';

const driverFactories: Record<
  string,
  (ctor: BridgeComponentConstructor<any>) => (deps?: any) => any
> = {
  react: createReactDriver,
  vue3: createVue3Driver,
  angular: createAngularDriver
};

/**
 * Resolve a framework driver for a bridge component constructor.
 * Called by both the static and instance .driver() methods.
 */
export function resolveDriver<P extends Record<string, any>>(
  name: string,
  ComponentClass: BridgeComponentConstructor<P>,
  deps?: Record<string, any>
): any {
  const factory = driverFactories[name];
  if (!factory) {
    throw new Error(
      `Unknown driver: ${name}. Available: ${Object.keys(driverFactories).join(', ')}`
    );
  }
  return factory(ComponentClass)(deps);
}
